import {
  getAddressTypeColor,
  getAddressTypeLabel,
  toProperCase,
} from '@/utils';
import { Box, Stack, Typography } from '@mui/material';
import { Popup } from 'react-map-gl/maplibre';

export function AddressPopup({
  hoverInfo: {
    longitude,
    latitude,
    feature: { properties },
  },
}) {
  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      offset={16}
      closeButton={false}
    >
      <Stack spacing={0.5}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {properties.label}
        </Typography>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              bgcolor: getAddressTypeColor(properties.typeCode),
              borderRadius: 6,
            }}
          />
          <Typography variant="caption">
            {getAddressTypeLabel(properties.typeCode) ?? 'Unknown'}
          </Typography>
        </Stack>
        <Stack spacing={0}>
          <Typography variant="caption" color="textSecondary">
            Address
          </Typography>
          {[
            toProperCase(
              [properties.houseNumber, properties.streetName]
                .filter(Boolean)
                .join(' '),
            ),
            [toProperCase(properties.city), properties.postCode]
              .filter(Boolean)
              .join(' '),
          ]
            .filter(Boolean)
            .map((line, i) => (
              <Typography
                key={i}
                variant="caption"
                sx={{ overflowWrap: 'break-word' }}
              >
                {line}
              </Typography>
            ))}
        </Stack>
      </Stack>
    </Popup>
  );
}
